import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Brain, CheckCircle2, ThumbsUp, ThumbsDown } from "lucide-react";
import { api } from "../../lib/api";

const RISK = { bajo: "badge-emerald", medio: "badge-amber", alto: "badge-danger" };

export default function ModuleAnalyze({ moduleKey = "decision_center", item, onRefresh }) {
  const [analisis, setAnalisis] = useState(item.analisis || null);
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/mod/${moduleKey}/items/${item.id}/analyze`);
      setAnalisis(data);
      toast.success("Análisis generado con IA");
      onRefresh?.();
    } catch (err) { toast.error(err?.response?.data?.detail || "No se pudo analizar"); }
    finally { setBusy(false); }
  };

  const rec = analisis?.recomendacion;
  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-4" data-testid="module-analyze">
      <div className="flex items-center justify-between gap-2">
        <div className="overline text-navy/40">Análisis de decisión (IA)</div>
        <button onClick={run} disabled={busy} className="btn btn-primary" data-testid="analyze-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Brain className="w-4 h-4" />} {analisis ? "Re-analizar" : "Analizar con IA"}
        </button>
      </div>

      {analisis && (
        <div className="space-y-4" data-testid="analyze-result">
          {rec && (
            <div className="rounded-xl border border-violet/30 bg-violet/5 p-4" data-testid="analyze-recommendation">
              <div className="flex items-center gap-2 text-violet text-sm font-medium"><CheckCircle2 className="w-4 h-4" /> Recomendación: {rec.opcion}</div>
              <p className="text-sm text-navy/70 mt-1">{rec.justificacion}</p>
              <div className="mt-2 flex items-center gap-2">
                <span className="text-xs text-navy/40">Confianza</span>
                <div className="flex-1 h-1.5 rounded-full bg-navy/10 overflow-hidden max-w-[160px]"><div className="h-full rounded-full bg-violet" style={{ width: `${rec.confianza || 0}%` }} /></div>
                <span className="text-xs text-navy/60 font-medium">{rec.confianza || 0}%</span>
              </div>
            </div>
          )}
          {analisis.resumen && <p className="text-sm text-navy/60 italic">{analisis.resumen}</p>}
          <div className="grid gap-3 sm:grid-cols-2">
            {(analisis.alternativas || []).map((a, i) => (
              <div key={i} className="card-surface p-3 space-y-2" data-testid={`analyze-alt-${i}`}>
                <div className="flex items-center justify-between gap-2"><span className="text-sm text-navy/80 font-medium truncate">{a.opcion}</span><span className={`badge ${RISK[a.riesgo] || "badge-muted"}`}>Riesgo {a.riesgo}</span></div>
                {(a.pros || []).map((p, j) => <div key={`p${j}`} className="flex items-start gap-1.5 text-xs text-navy/60"><ThumbsUp className="w-3.5 h-3.5 text-emerald-600 mt-0.5 shrink-0" />{p}</div>)}
                {(a.contras || []).map((c, j) => <div key={`c${j}`} className="flex items-start gap-1.5 text-xs text-navy/60"><ThumbsDown className="w-3.5 h-3.5 text-destructive/70 mt-0.5 shrink-0" />{c}</div>)}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
